var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { ApiBatchRemoveSpaces } from '@/infrastructure/api-functions/api-batch-remove-spaces';
let RemoveSpacesRepositoryImpl = class RemoveSpacesRepositoryImpl {
    constructor(_apiBatchRemoveSpaces) {
        this._apiBatchRemoveSpaces = _apiBatchRemoveSpaces;
    }
    async removeSpaces(spaceIds) {
        const data = await this._apiBatchRemoveSpaces.batchRemoveSpaces(spaceIds);
        return data.map((item) => {
            return {
                spaceId: item.space_id,
            };
        });
    }
};
RemoveSpacesRepositoryImpl = __decorate([
    injectable(),
    __param(0, inject(ApiBatchRemoveSpaces)),
    __metadata("design:paramtypes", [typeof (_a = typeof ApiBatchRemoveSpaces !== "undefined" && ApiBatchRemoveSpaces) === "function" ? _a : Object])
], RemoveSpacesRepositoryImpl);
export { RemoveSpacesRepositoryImpl };
